<template>
  <div>
    <b-modal
      id="addevent-modal"
      style="justify-content: space-around"
      hide-footer
      title="رویداد جدید"
    >
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form @submit.stop.prevent="onSubmit">
        <div>
          <b-row>
            <b-col>
              <b-form-group id="Type-gr" label="نوع رویداد:" label-for="Type">
                <MDDropdown
                  v-bind:group="107"
                  v-model="Input.mdid107_type"
                ></MDDropdown>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="تاریخ رویداد"
                label-for="input-2"
              >
                <date-picker required v-model="Input.date_done"></date-picker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="ساعت رویداد: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  required
                  v-model="Input.time_done"
                  placeholder="00:00"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group
            id="input-group-5"
            label="توضیحات: "
            label-for="input-5"
          >
            <b-form-textarea
              required
              id="input-5"
              v-model="Input.description"
              placeholder="توضیحات"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
        </div>

        <b-row class="mt-3">
          <b-col>
            <b-button
              style="width: 100%"
              variant="danger"
              @click="hideAddEventModal"
              >بازگشت</b-button
            >
          </b-col>
          <b-col>
            <b-button style="width: 100%" variant="primary" @click="addEvent"
              >ذخیره</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<style>
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import persianDate from "../../../helpers/persianDate";
import MDDropdown from "../../../components/MDDropdown";

export default {
  name: "AddEvent",
  components: {
    persianDate,
    MDDropdown,
  },
  props: ["afterdone", "customer_id", "event_id", "task_id"],
  data: function () {
    return {
      Input: {
        id: 0,
        mdid107_type: "",
        date_done: "",
        time_done: "",
        description: "",
        customer_id: 0,
        task_id: 0,
      },
      errors: [],
    };
  },
  watch: {
    event_id: function (newVal, oldVal) {
      if (newVal != null) {
        this.EditEvent();
      }
    },
  },
  computed: {},
  methods: {
    hideAddEventModal: function () {
      this.$bvModal.hide("addevent-modal");
    },
    addEvent(evt) {
      this.errors = [];

      if (this.event_id != null) {
        this.Input.id = this.event_id;
      }
      if (this.customer_id != null) {
        this.Input.customer_id = this.customer_id;
      }
      if (this.task_id != null) {
        this.Input.task_id = this.task_id;
      }
      httpHelper.postData("crmevents", this.Input).then((response) => {
        if (response.success) {
          this.Input.description = "";
          this.Input.mdid107_type = "";
          this.Input.date_done = null;
          this.Input.time_done = null;

          this.errors = [];
          this.afterdone();
          this.hideAddEventModal();
          //this.event_id = null;
        } else {
          for (var key in response.error) {
            response.error[key].forEach((element) => {
              this.errors.push(element);
            });
          }
        }
      });
    },
    EditEvent() {
      if (this.event_id != null) {
        this.title_modal = "ویرایش رویداد";
        httpHelper.getData("crmevents?id=" + this.event_id).then((res) => {
          if (res.success && res.result !== null) {
            this.Input = res.result;
            this.Input.time_done = persianDate.getTimeWithOutSecend(
              this.Input.time_done
            );
          }
        });
      } else {
        this.title_modal = "رویداد جدید";
        this.Input.description = "";
        this.Input.mdid107_type = "";
        this.Input.date_done = null;
        this.Input.time_done = null;

        this.errors = [];
      }
    },
  },
};
</script>
